/** Suppliers on the platform in the console (cap. 446). Twin of `it.ts`. */
export default {
  stato: {
    colonna: 'On the platform',
    in_attesa: 'Pending',
    approvato: 'Approved',
    sospeso: 'Suspended',
    dal: 'since {{data}}',
    spiega_in_attesa: 'Companies cannot see it yet: no goods, tenders or agreements.',
  },
  azioni: {
    approva: 'Approve',
    sospendi: 'Suspend',
    riattiva: 'Reactivate',
  },
  dialogo_sospendi: {
    titolo: 'Suspend «{{fornitore}}»',
    testo: 'Companies will no longer see it for goods, tenders and new agreements. Discounts in quotes do not change.',
    motivo: 'Why',
    motivo_aiuto: 'It stays in the supplier’s history.',
    annulla: 'Cancel',
    conferma: 'Suspend the supplier',
  },
  esito: {
    approvato: '{{fornitore}} is approved: from now on companies can see it.',
    sospeso: '{{fornitore}} is suspended.',
    errore: 'The status did not change: {{motivo}}',
  },
} as const;
